import { v4 as uuidv4 } from 'uuid';
import { JSONSchema7 } from 'json-schema';
import ControlKind from '../../../Shared/controlKind';
import { GridSize } from '../../../Shared/Enums/gridSize';

export default (controlId: string, pageExternalId: string, order: number) => {
  return {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: `#${pageExternalId}/${controlId}`,
    type: 'object',
    properties: {
      version: {
        $id: `#${pageExternalId}/${controlId}/version`,
        default: 3,
        type: 'number'
      },
      label: {
        $id: `#${pageExternalId}/${controlId}/label`,
        default: 'Date Field',
        type: 'string'
      },
      id: {
        $id: `#${pageExternalId}/${controlId}/id`,
        default: `${uuidv4().replace(/-/g, '')}`,
        type: 'string'
      },
      value: {
        $id: `#${pageExternalId}/${controlId}/value`,
        default: '',
        type: 'string'
      },
      type: {
        $id: `#${pageExternalId}/${controlId}/type`,
        default: ControlKind.DATE,
        type: 'string'
      },
      required: {
        $id: `#${pageExternalId}/${controlId}/required`,
        default: false,
        type: 'boolean'
      },
      minimumDate: {
        $id: `#${pageExternalId}/${controlId}/minimumDate`,
        default: new Date('01/01/1900').toISOString(),
        type: 'string'
      },
      maximumDate: {
        $id: `#${pageExternalId}/${controlId}/maximumDate`,
        default: new Date('01/01/2100').toISOString(),
        type: 'string'
      },
      order: {
        $id: `#${pageExternalId}/${controlId}/order`,
        default: order,
        type: 'integer'
      },
      conditional: {
        $id: `#${pageExternalId}/${controlId}/conditional`,
        default: false,
        type: 'boolean'
      },
      gridSize: {
        $id: `#${pageExternalId}/${controlId}/gridSize`,
        default: GridSize.FULL,
        type: 'number'
      }
    }
  } as JSONSchema7;
};
